import { Route, Routes, HashRouter } from 'react-router-dom'
import { Login, Welcome } from './pages'
import { AuthProvider } from './context/AuthProvider'
import { CustomisationProvider } from './context/CustomisationProvider'
import { ProtectedRoute } from './components/common'
import 'antd/dist/reset.css'
import './App.css'

export const LOGIN_PATH = '/'
export const WELCOME_ROUTE_PATH = '/welcome'

const App = () => {
  return (
    <HashRouter basename="/">
      <CustomisationProvider>
        <AuthProvider>
          <Routes>
            <Route path={LOGIN_PATH} element={<Login />} />
            <Route
              path={WELCOME_ROUTE_PATH}
              element={
                <ProtectedRoute>
                  <Welcome />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </CustomisationProvider>
    </HashRouter>
  )
}

export default App
